import getApiClient from '@/plugins/api'

export default {
  loadSalesData: function () {
    const self = this,
      api = getApiClient(self.$store)

    self.$store.commit('startLoading')

    api.get('/agency/sales_report')
      .then(result => {
        self.salesData = result.data
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  }
}
